/**
 * voice-v8 — geteilte aufklappbare Meldungs-Karte (Job-Meldungen wie der
 * Flugpreis-Waechter). Wird in Chat (fillBotBubble) UND Glocke (tickets-view)
 * verwendet — DRY, ein Erscheinungsbild. Kopf (MELDUNG-Pill + Titel +
 * Kernzeile) sichtbar, Details auf Tipp.
 */
import { renderMarkdown } from "./markdown.js";

export function buildMeldungCard(title: string, bodyMd: string): HTMLElement {
  const wrap = document.createElement("div");
  wrap.className = "job-meldung";
  const headBtn = document.createElement("button");
  headBtn.type = "button";
  headBtn.className = "job-meldung-head";
  const kicker = document.createElement("span");
  kicker.className = "job-meldung-kicker";
  kicker.textContent = "MELDUNG";
  const titleEl = document.createElement("span");
  titleEl.className = "job-meldung-title";
  titleEl.textContent = title;
  const gist = document.createElement("span");
  gist.className = "job-meldung-gist";
  const firstLine = bodyMd.split("\n").find((l) => l.trim().length > 0) ?? "";
  gist.textContent = firstLine
    .replace(/[#*_`|]/g, " ")
    .replace(/-{2,}/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, 110);
  const chev = document.createElement("span");
  chev.className = "job-meldung-chev";
  chev.textContent = "›";
  headBtn.append(kicker, titleEl, chev, gist);
  const body = document.createElement("div");
  body.className = "job-meldung-body";
  body.hidden = true;
  renderMarkdown(body, bodyMd);
  headBtn.addEventListener("click", () => {
    body.hidden = !body.hidden;
    wrap.classList.toggle("is-open", !body.hidden);
  });
  wrap.append(headBtn, body);
  return wrap;
}
